enum AbsenceTypology {
    Other = "Other",
    NotAvailable = "NotAvailable"
}

export default AbsenceTypology;